import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import { LIST_CAMPAIGN_NAMES } from '../../graphql/campaign/query';
import type { ResponseListCampaignNames } from '../../types';
import { Error } from '../common/Error';
import { GenericDropdown } from './GenericDropdown';

type UserDropdownProps = {
  control: any;
  validation?: any;
  name: string;
  label?: string;
  placeholder?: string;
  multi?: boolean;
  searchable?: boolean;
  storeFullOption?: boolean;
  hasAddButton?: boolean;
  error?: string;
  isClearable?: boolean;
};

export const CampaignDropdown = ({
  control,
  name,
  label,
  validation,
  placeholder,
  multi = false,
  searchable = true,
  storeFullOption = false,
  hasAddButton = false,
  error,
  isClearable = true,
}: UserDropdownProps) => {
  const [options, setOptions] =
    useState<{ value: string; label: string; image?: string }[]>();
  const [open, setOpen] = useState(false);
  const [createdUser, setCreatedUser] = useState<string | null>(null);

  useEffect(() => {
    if (createdUser) {
      const newUserOption = options?.find(
        (option) => option.value === createdUser,
      );
      if (newUserOption) {
        // setValue(name, storeFullOption ? newUserOption : newUserOption.value);
      }
    }
  }, [createdUser, options, name, storeFullOption]);

  const { loading } = useQuery<ResponseListCampaignNames>(LIST_CAMPAIGN_NAMES, {
    onCompleted: (data: ResponseListCampaignNames) =>
      setOptions(
        data.listCampaignNames.data.map((u) => ({
          label: u.name,
          value: u.id,
        })),
      ),
  });

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row items-end gap-1">
        <GenericDropdown
          isClearable={isClearable}
          control={control}
          name={name}
          storeFullOption={storeFullOption}
          label={label}
          isSearchable={searchable}
          options={options || []}
          isMulti={multi}
          validation={validation}
          isLoading={loading}
          placeholder={placeholder || label || ''}
        />
      </div>
      {error && <Error error={error} />}
    </div>
  );
};
